import {
  Alert,
  Button,
  Checkbox,
  FormContainer,
  FormItemCheckBox,
  ContainerCheckbox,
  FormItemInput,
  DetailInput,
  FormItem,
  Line,
  PhoneInput,
  Title,
  StyledModal,
} from './styles'
import { Fragment } from 'react'
import { Form } from 'antd'
import SupportingDocumentsModalHook from './SupportingDocumentsModal.hook'
import { RequestDocumentHistory } from '@/services/healthClaim/useRequestDocumentList/types'

const SupportingDocumentsModal = ({
  isModalOpen,
  handleOk,
  handleCancel,
  selectedRecord,
}: {
  isModalOpen: boolean
  handleOk?: () => void
  handleCancel: () => void
  selectedRecord?: RequestDocumentHistory
}) => {
  const {
    onClose,
    onSubmit,
    isSubmitDisabled,
    form,
    onFinish,
    textAlertInfo,
    textAlertWarning,
    showAlertInfo,
    showAlertWarning,
    checkboxItems,
    isReadOnly,
    isCreateMode,
    hasSelectedRecord,
    isUploadedRecord,
    onResend,
    disabledTypes,
    canResendSms,
    cannotEditPhoneNumber,
  } = SupportingDocumentsModalHook({ isModalOpen, handleOk, handleCancel, selectedRecord })

  return (
    <StyledModal
      title="ขอเอกสารเพิ่มเติม"
      open={isModalOpen}
      width={650}
      data-testid="supporting-document-modal"
      centered
      onCancel={onClose}
      footer={[
        <Button
          key="cancel"
          data-testid="supporting-document-modal-button-cancel"
          onClick={onClose}
        >
          {hasSelectedRecord ? 'ปิด' : 'ยกเลิก'}
        </Button>,
        ...(hasSelectedRecord
          ? [
              ...(canResendSms
                ? [
                    <Button
                      key="resend"
                      type="primary"
                      data-testid="supporting-document-modal-button-resend"
                      onClick={onResend}
                    >
                      ส่งใหม่อีกครั้ง
                    </Button>,
                  ]
                : []),
            ]
          : [
              <Button
                key="submit"
                type="primary"
                data-testid="supporting-document-modal-button-confirm"
                onClick={onSubmit}
                disabled={isSubmitDisabled}
              >
                {isCreateMode ? 'บันทึก' : 'ส่ง'}
              </Button>,
            ]),
      ]}
    >
      <FormContainer form={form} layout="vertical" onFinish={onFinish}>
        {showAlertInfo && <Alert type="info" showIcon message={textAlertInfo} />}
        <Title>เลือกเอกสาร</Title>
        {showAlertWarning && <Alert type="warning" showIcon message={textAlertWarning} />}
        {disabledTypes.size > 0 && !isReadOnly && (
          <Alert
            type="warning"
            showIcon
            style={{ marginTop: 16 }}
            message={`ไม่สามารถขอเอกสารบางประเภทซ้ำได้ (รอการอัปโหลดเอกสาร): ${Array.from(
              disabledTypes,
            )
              .map((k) => checkboxItems.find((i) => i.key === k)?.label)
              .filter(Boolean)
              .join(', ')}`}
          />
        )}
        <ContainerCheckbox>
          {checkboxItems.map(({ key, label }) => (
            <Fragment key={key}>
              <FormItemCheckBox name={key} valuePropName="checked">
                <Checkbox disabled={isReadOnly || disabledTypes.has(key)}>{label}</Checkbox>
              </FormItemCheckBox>

              <Form.Item noStyle dependencies={[key]}>
                {({ getFieldValue }) =>
                  getFieldValue(key) ? (
                    <FormItemInput name={['requestDetail', key]}>
                      <DetailInput
                        placeholder="ระบุรายละเอียดที่ต้องการ"
                        data-testid={`supporting-document-modal-input-${key}-detail`}
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        maxLength={255}
                        showCount={!isReadOnly}
                        disabled={isReadOnly}
                      />
                    </FormItemInput>
                  ) : null
                }
              </Form.Item>
            </Fragment>
          ))}
        </ContainerCheckbox>
        <Line />
        <Title>ระบุเบอร์โทรศัพท์ที่ต้องการส่ง SMS</Title>
        <FormItem
          label="โทรศัพท์มือถือ"
          name="phoneNumber"
          rules={
            cannotEditPhoneNumber || isUploadedRecord
              ? []
              : [
                  { required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' },
                  { pattern: /^\d+$/, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' },
                  { min: 10, message: 'กรุณากรอกเบอร์โทรศัพท์อย่างน้อย 10 หลัก' },
                ]
          }
        >
          <PhoneInput
            placeholder="ระบุเบอร์โทรศัพท์"
            data-testid="supporting-document-modal-input-phone"
            inputMode="numeric"
            minLength={10}
            maxLength={10}
            disabled={cannotEditPhoneNumber || isUploadedRecord}
          />
        </FormItem>
      </FormContainer>
    </StyledModal>
  )
}

export default SupportingDocumentsModal
